module.exports = __webpack_public_path__ + "img/donut-tab.7f37f453.svg";